import { render, staticRenderFns } from "./MedicalInstitutionEdit.vue?vue&type=template&id=28bcd506"
import script from "./MedicalInstitutionEdit.vue?vue&type=script&lang=js"
export * from "./MedicalInstitutionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports